module.exports = __webpack_public_path__ + "static/media/IQ5_Animation_Loading_Blanc.fcfafe20.gif";